import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import classNames from "classnames";
import styles from "../styles/prediction-widget.module.scss";

const PredictionsWidgetAsyncComponent = AsyncComponent(async () => import('./predictions-widget' /* webpackChunkName: "predictions-widget" */ ));

export const PredictionsWidgetAsync = (props) => {
  return props.shouldUseSuspense ? <React.Suspense fallback={<div className={classNames(styles.placeholder, {[styles.small_view]: props.isSmallView}, props.className)}/>}>
    <PredictionsWidgetAsyncComponent {...props}/>
  </React.Suspense> : <PredictionsWidgetAsyncComponent {...props}/>
}
